import { DataTableColumnDef } from "@/components/molecules";
import { MyVehicleTableData, VehicleRegistrationStatus } from "./types";

export const myVehiclesColumns: DataTableColumnDef<MyVehicleTableData>[] = [
  {
    header: "Year",
    size: 100,
    accessorKey: "year",
    sortDescFirst: false,
  },
  {
    header: "Make",
    accessorKey: "make",
    cell: (props) => props.row.original.make,
    size: 150,
    sortDescFirst: false,
  },
  {
    header: "Model",
    accessorKey: "model",
    size: 150,
    sortDescFirst: false,
  },
  {
    header: "Number Plate",
    accessorKey: "registration_number",
    cell: (props) => props.row.original.numberPlate,
    size: 150,
    sortDescFirst: false,
  },
  {
    header: "Nickname",
    size: 150,
    id: "identifier",
    accessorKey: "nickname",
    sortDescFirst: false,
  },
  {
    header: "Color",
    id: "color",
    cell: (props) => props.row.original.color,
    size: 150,
  },
  {
    header: "Currently Assigned Driver",
    id: "driver",
    cell: (props) => props.row.original.driver,
    size: 150,
  },
  {
    header: "Actions",
    id: "actions",
    cell: (props) => props.row.original.actions,
    maxSize: 75,
  },
];

export const statusStyles: Record<VehicleRegistrationStatus, string> = {
  verified: "!border-neutral-surface-gray !bg-neutral-surface-gray",
  expiring: "!border-warning !bg-warning-light hover:!bg-warning-light",
  expired: "!border-danger !bg-danger-light hover:!bg-danger-light",
  unverified: "!border-neutral-surface-gray !bg-neutral-surface-gray",
  unknown: "!border-danger !bg-danger-light hover:!bg-danger-light",
  "missing-details": "!border-danger !bg-danger-light hover:!bg-danger-light",
};
